import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { logEvent } from '~/config/firebase.config';
import { safeScreenPath } from '~/services/screenTab/screenTabLock';

import styles from './OtherTab.module.css';

/**
 * Page d'attente d'un onglet écran mis en veille parce que le même bar est ouvert
 * dans un autre onglet (services/screenTab/screenTabLock.ts). On y arrive par un
 * rechargement complet : plus de socket, de jeu ni de son dans cet onglet.
 * « Utiliser cet onglet » recharge l'écran d'origine, qui met à son tour l'autre
 * onglet (désormais caché) en veille.
 */
export function OtherTab() {
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();
    const target = safeScreenPath(searchParams.get('back'), window.location.origin) ?? '/home';

    // Une mise en veille = un événement : `c` n'est posé que par la mise en veille,
    // et retiré aussitôt (un rechargement de cette page ne recompte pas).
    useEffect(() => {
        const clientID = searchParams.get('c');
        if (!clientID) return;
        logEvent('screen_tab_dormant', clientID, { clientID });
        const next = new URLSearchParams(searchParams);
        next.delete('c');
        setSearchParams(next, { replace: true });
    }, []);

    return (
        <div className={styles.root}>
            <h1 className={styles.title}>{t('screenTab.title')}</h1>
            <p className={styles.text}>{t('screenTab.text')}</p>
            <button type="button" className={styles.button} onClick={() => window.location.assign(target)}>
                {t('screenTab.useHere')}
            </button>
        </div>
    );
}
